import React from "react";
import {
  Card,
  CardContent,
  Typography,
  LinearProgress,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

// Helper function to determine color based on score
const getScoreColor = (score) => {
  if (score <= 3) return "error"; // Red
  if (score <= 6) return "warning"; // Yellow
  if (score <= 10) return "success"; // Green
  return "error";
};

// Score bar component
const ScoreBar = ({ label, score }) => {
  const color = getScoreColor(score);

  return (
    <Box sx={{ mb: 2 }} fullWidth>
      <Typography variant="subtitle1" gutterBottom>
        {label}: {score}/10
      </Typography>
      <Typography variant="subtitle2" color={color} gutterBottom>
        <b>
          {score <= 3
            ? "Poor"
            : score <= 6
            ? "Good"
            : score <= 10
            ? "Excellent"
            : "N/A"}
        </b>
      </Typography>
      <LinearProgress
        variant="determinate"
        value={(score / 10) * 100}
        color={color}
        sx={{ height: 10, borderRadius: 5 }}
        fullWidth
      />
    </Box>
  );
};

// Main component
const SoilTestScoreCard = ({ scores, title, showHealthScore }) => {
  const { t } = useTranslation();
  const { nitrogen, potassium, phosphorous, irrigation, crop_growth } =
    scores || {};

  if (!scores) return null;

  return (
    <Card sx={{ mt: 2, width: "-webkit-fill-available" }}>
      <CardContent
        sx={{
          padding: "12px",
          width: "-webkit-fill-available",
        }}
      >
        <Typography variant="h6" component="div" gutterBottom>
          {title}
        </Typography>
        <ScoreBar label={t("Nitrogen")} score={nitrogen} />
        <ScoreBar label={t("Potassium")} score={potassium} />
        <ScoreBar label={t("Phosphorus")} score={phosphorous} />
        {showHealthScore && (
          <>
            {crop_growth && (
              <ScoreBar label={t("Crop Growth")} score={crop_growth} />
            )}
            {irrigation && (
              <ScoreBar label={t("Irrigation")} score={irrigation} />
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SoilTestScoreCard;
